export enum EventNames {
  PointerDown = 'pointerdown',
  PointerMove = 'pointermove',
  PointerUp = 'pointerup',
  DragEnter = 'dragenter',
  DragEnd = 'dragend',
  DragLeave = 'dragleave',
  DragOver = 'dragover',
  Drop = 'drop',
  Scroll = 'scroll',
  Wheel = 'wheel',
  ContextMenu = 'contextmenu',
  KeyDown = 'keydown',
  KeyUp = 'keyup',
  DblClick = 'dblclick'
}
